import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardDataWrapper } from './PropertyCardDataWrapper.styles';

/**
 * A container for the property data and action buttons in a `PropertyCard`.
 *
 * @since 8.63.0
 */
export var PropertyCardDataWrapper = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardDataWrapper, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardDataWrapper.displayName = 'PropertyCard.DataWrapper';